
    // TEXT input for "ProductOverview"
    const input = {
    // Product REVIEWS
    reviews: {
        href: 'https://www.google.com/',
        average: 4,
        totalCount: 117
    },

    // Product DESCRIPTIONS
    product: {
        // General Information about the product
        name: 'Adidas Originals Retropy F2 Sneaker Mens',
        price: '$89',
        to: 'footwear',
        id: 'product-footwear-adidas',
        
        // Product Breadcrumbs
        breadcrumbs: [
            { id: 1, name: 'Footwear', to: '/footwear' },
            // { id: 2, name: 'Clothing', to:'/men/clothing'},
            // { id: 3, name: 'Tops', to: '/men/clothing/tops' },
        ],

        //Product Images
        images: [
            {
            src: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/footwear/adidas.png',
            alt: 'image 1',
            },
            {
            src: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/footwear/adidas/adidas2.png',
            alt: 'image 2',
            },
            {
            src: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/footwear/adidas/adidas3.png',
            alt: 'image 3',
            },
            {
            src: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/footwear/adidas/adidas4.png',
            alt: 'image 4',
            },
        ],

        // Product Colors
        colors: [
            { name: 'White', class: 'bg-white', selectedClass: 'ring-gray-400' },
            { name: 'Gray', class: 'bg-gray-200', selectedClass: 'ring-gray-400' },
            { name: 'Black', class: 'bg-gray-900', selectedClass: 'ring-gray-900' },
        ],

        // Product Sizing
        sizes: [
            { name: '40', inStock: true },
            { name: '41', inStock: true },
            { name: '42', inStock: true },
            { name: '43', inStock: true },
            { name: '44', inStock: true },
            { name: '45', inStock: true },
            { name: '46', inStock: true },
        ],

        // Product Introduction
        description:
            "The adidas Originals Retropy F2 Sneaker for men blends retro aesthetics with modern design, drawing inspiration from 1980s running styles while incorporating updated proportions and contemporary materials.",
        
        // Product Bulletpoints
        highlights: [
            'Shown: Space Purple',
            'Style: DO7392-567',
        ],
        
        // Product Additional Information
        details:
            'This product is made with at least 75% organic cotton fibers',
    },

    // Personalized Recommendation per Product
    recommendation: [
        {
            id: 2,
            name: 'Nike Air Max Furyosa',
            category: "Nike Footwear",
            href: '/footwear/nike-air-max',
            imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/footwear/nike.png',
            imageAlt: "Front of men's Basic Tee in black.",
            price: '$99',
            color: 'Black',
        },
        {
            id: 3,
            name: "New Balance 327 Moonbeam 'New Spruce'",
            category: "New Balance Footwear",
            href: '/footwear/new-balance-327',
            imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/footwear/nb.png',
            imageAlt: "Front of men's Basic Tee in black.",
            price: '$119',
            color: 'Black',
        },
        {
            id: 4,
            name: 'ACG Jacket',
            category: "Men's Jackets",
            href: '/men/clothing/tops/nike4',
            imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/men/4/product_men_4-1.jpg',
            imageAlt: "Front of men's Basic Tee in black.",
            price: '$35',
            color: 'Black',
        },
        {
            id: 5,
            name: 'Nike Sportswear Premium Essentials',
            category: "Men's T-Shirts",
            href: '/men/clothing/tops/nike1',
            imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/men/1/product_men_1-1.jpg',
            imageAlt: "Front of men's Basic Tee in black.",
            price: '$35',
            color: 'Black',
        },
        // More products...
    ]

    }

    export default input
    
